import { useLocation } from 'react-router-dom';

const funcionOrdenarColumnas = (orderBy, order, setOrderBy, setOrder) => (event, valorCol) => {
    const isAsc = orderBy === valorCol && order === 'asc';
    const nuevoOrden = isAsc ? 'desc' : 'asc';
    setOrder(nuevoOrden);
    setOrderBy(valorCol);
    
    console.log("orden", nuevoOrden.toUpperCase());
    console.log("propiedad", valorCol);
    
    const urlActual = new URL(window.location);
    const params = new URLSearchParams(urlActual.search);
    
    params.set('ordenarColumna', valorCol);
    params.set('orden', nuevoOrden.toUpperCase());
    
    params.set('pagina', '1');
    
    const nuevaURL = `${urlActual.pathname}?${params.toString()}`;
    console.log("nuevaURL", nuevaURL);
    
    return nuevaURL;
}


export default funcionOrdenarColumnas;
